export const chaseLogsData = [
  // {
  //   label: "Full Payment via Journey SBV1",
  //   value: "full-payment-via-journey-sbv1",
  //   fields: [
  //     {
  //       name: "fromPolicyReference",
  //       placeHolder: "Policy Reference Number",
  //       type: "string",
  //       isRequired: true,
  //     },
  //     {
  //       name: "collectedAmount",
  //       placeHolder: "Collected Amount",
  //       isRequired: true,
  //     },
  //     {
  //       name: "carpAmount",
  //       placeHolder: "Carp Amount",
  //       isRequired: true,
  //     },
  //   ],
  // },
  {
    label: "Payment via Journey SBV1",
    value: "partial-payment-via-journey-sbv1",
    fields: [
      {
        name: "fromPolicyReference",
        placeHolder: "Policy Reference Number",
        type: "string",
        isRequired: true,
      },
      {
        name: "collectedAmount",
        placeHolder: "Collected Amount",
        isRequired: true,
      },
      {
        name: "carpAmount",
        placeHolder: "Carp Amount",
        isRequired: true,
      },
      {
        name: "quoteRefference",
        placeHolder: "Quote Refference",
        type: "string",
        isRequired: true,
      },
      {
        name: "orderid",
        placeHolder: "Stripe Order ID",
        type: "string",
        isRequired: false,
      },
    ],
  },
  {
    label: "Chargeback Request Initiated",
    value: "chargeback-request-initiated",
    fields: [
      {
        name: "collectedAmount",
        placeHolder: "Collected Amount",
        isRequired: true,
      },
      {
        name: "chargebackType",
        placeHolder: "Chargeback Type",
        type: "select",
        options: [
          { value: "prev-canx", label: "Pre Cancellation" },
          { value: "post-canx", label: "Post Cancellation" },
        ],
        isRequired: true,
      },
      {},
    ],
  },
  {
    label: "Chargeback Unsuccessful by Customer",
    value: "chargeback-unsuccessful-by-customer",
    fields: [
      {
        name: "collectedAmount",
        placeHolder: "Collected Amount",
        isRequired: true,
      },
      {
        name: "chargebackType",
        placeHolder: "Chargeback Type",
        type: "select",
        options: [
          { value: "prev-canx", label: "Pre Cancellation" },
          { value: "post-canx", label: "Post Cancellation" },
        ],
        isRequired: true,
      },
      {},
    ],
  },
  {
    label: "Chargeback Successful by Customer",
    value: "chargeback-successful-by-customer",
    fields: [
      {
        name: "collectedAmount",
        placeHolder: "Collected Amount",
        isRequired: true,
      },
      {},
      {},
    ],
  },
  {
    label: "Debt Write Off",
    value: "partial-debt-write-off",
    fields: [
      {
        name: "reason",
        placeHolder: "Reason For Write Off",
        type: "select",
        options: [
          { value: "Death", label: "Death" },
          { value: "IVA", label: "IVA" },
          { value: "Bankruptcy", label: "Bankruptcy" },
          { value: "Fraud Proven", label: "Fraud Proven" },
          { value: "Complaint/GOGW", label: "Complaint/GOGW" },
          { value: "Staff error", label: "Staff error" },
          { value: "Prison", label: "Prison" },
        ],
        isRequired: true,
      },
      {
        name: "collectedAmount",
        placeHolder: "Collected Amount",
        isRequired: true,
      },
      {
        name: "outstandingBalance",
        placeHolder: "Outstanding Balance",
        isRequired: false,
      },
    ],
  },
  // {
  //   label: "Full Debt Write Off",
  //   value: "full-debt-write-off",
  //   fields: [
  //     {
  //       name: "amount",
  //       placeHolder: "Amount",
  //       isRequired: false,
  //     },
  //     {
  //       name: "collectedAmount",
  //       placeHolder: "Collected Amount",
  //       isRequired: true,
  //     },
  //     {
  //       name: "outstandingBalance",
  //       placeHolder: "Outstanding Balance",
  //       isRequired: false,
  //     },
  //   ],
  // },
  {
    label: "Refund Raised",
    value: "refund-raised",
    fields: [
      {},
      {
        name: "collectedAmount",
        placeHolder: "Collected Amount",
        isRequired: true,
      },
      {},
    ],
  },
  // {
  //   label: "Payment Plan Collected",
  //   value: "payment-plan-collected",
  //   fields: [
  //     {
  //       name: "collectedAmount",
  //       placeHolder: "Collected Amount",
  //       isRequired: true,
  //     },
  //     {
  //       name: "planType",
  //       placeHolder: "Type",
  //       type: "select",
  //       options: [
  //         { value: "3-month-plan", label: "3 Month Plan" },
  //         { value: "6-month-plan", label: "6 Month Plan" },
  //         { value: "12-month-plan", label: "12 Month Plan" },
  //       ],
  //       isRequired: true,
  //     },
  //     {},
  //   ],
  // },
  {
    label: "Payment Collected",
    value: "payment-collected",
    fields: [
      {
        name: "platform",
        placeHolder: "Collection Platform",
        type: "select",
        options: [
          { value: "cdl", label: "CDL" },
          { value: "acturis", label: "Acturis" },
          { value: "ogi", label: "OGI" },
        ],
        isRequired: true,
      },
      {
        name: "collectedAmount",
        placeHolder: "Collected Amount",
        isRequired: true,
      },
      {
        name: "outstandingBalance",
        placeHolder: "Outstanding Balance",
        isRequired: false,
      },
    ],
  },

  {
    label: "",
    value: "default",
    fields: [
      {
        name: "amount",
        placeHolder: "Amount",
        isRequired: false,
      },
      {
        name: "collectedAmount",
        placeHolder: "Collected Amount",
        isRequired: true,
      },
      {
        name: "outstandingBalance",
        placeHolder: "Outstanding Balance",
        isRequired: false,
      },
    ],
  },
];

/** Which CDL call a debt-plan-sync-failed log is about, only the first two can be retried */
export const debtSyncStepLabels: Record<string, string> = {
  stripe_debt_plan: "Plan setup on CDL",
  stripe_pay_instalment: "Instalment update on CDL",
  cancel_stripe_plan: "Plan cancel on CDL",
  installment_plan_setup: "DebtSure plan setup",
};

export const retryableDebtSyncSteps = ["stripe_debt_plan", "stripe_pay_instalment"];
